import styled from 'styled-components';
import { colors } from '../colors';

interface headingProps {
	margin?: string;
	padding?: string;
	marginTop?: string;
	marginBottom?: string;
	marginLeft?: string;
	marginRight?: string;
	fontSize?: string;
	float?: string;
	width?: string;
	textAlign?: string;
	lineHeight?: string;
	display?: string;
	h1?: boolean;
	h2?: boolean;
	h3?: boolean;
	h4?: boolean;
	h5?: boolean;
	h6?: boolean;
	normal?: boolean;
	semiBold?: boolean;
	Bold?: boolean;
	font13?: boolean;
	textGrey?: boolean;
	Grey58?: boolean;
	textWrap?: boolean;
	fontSize20?: boolean;
	fileName?: boolean;
	fileType?: boolean;
	loginText?: boolean;
	loginSubText?: boolean;
	loginHeading?: boolean;
	loginHeadingSub?: boolean;
}
const Heading = styled.h1<headingProps>`
	margin: 0px;
    max-width: 100%;
	margin: ${({ margin }) => margin};
	padding: ${({ padding }) => padding};
	margin-top: ${({ marginTop }) => marginTop}!important;
	margin-bottom: ${({ marginBottom }) => marginBottom}!important;
	margin-left: ${({ marginLeft }) => marginLeft}!important;
	margin-right: ${({ marginRight }) => marginRight}!important;
	font-size: ${({ fontSize }) => fontSize}!important;
	float: ${({ float }) => float}!important;
	width: ${({ width }) => width}!important;
	text-align: ${({ textAlign }) => textAlign}!important;
	line-height: ${({ lineHeight }) => lineHeight}!important;
	display: ${({ display }) => display}!important;
	cursor: auto;
	
	${({ textWrap }) =>
		textWrap &&
		`overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	`}
	${({ Grey58 }) =>
		Grey58 &&
		`color: ${colors.Grey58};
	`}
	${({ normal }) =>
		normal &&
		`font-family: 'RubikRegular'!important;
	`}
	${({ semiBold }) =>
		semiBold &&
		`font-family: 'RubikMedium'!important;
	`}
	${({ Bold }) =>
		Bold &&
		`font-family: 'RubikBold'!important;
	`}
	${({ h1 }) =>
		h1 &&
		`font-size: 26px;
	`}
	${({ h2 }) =>
		h2 &&
		`font-size: 22px;
	`}
	${({ h3 }) =>
		h3 &&
		`font-size: 18px;
		line-height:21px;
	`}
	${({ h4 }) =>
		h4 &&
		`font-size: 16px;
		line-height: 19px;
	`}
	${({ h5 }) =>
		h5 &&
		`font-size: 14px;
	`}
	${({ h6 }) =>
		h6 &&
		`font-size: 12px;
	`}
	${({ font13 }) =>
		font13 &&
		`font-size: 13px;
		line-height: 19px;
	`}
	${({ fontSize20 }) =>
		fontSize20 &&
		`font-size: 20px;
		line-height: 24px;
	`}
	${({ textGrey }) =>
		textGrey &&
		`color: ${colors.Grey58};
	`}
	${({ fileName }) =>
		fileName &&
		`color: ${colors.Grey58};
		font-size: 18px;
		line-height: 21px;
		span{
			color: ${colors.Black};
			font-family: 'RubikMedium'!important;
		}
	`}
	${({ fileType }) =>
		fileType &&
		`color: ${colors.Grey58};
		font-size: 13px;
		line-height: 19px;
		span{
			color: ${colors.Black};
			font-family: 'RubikMedium'!important;
		}
		
	`}
	${({ loginText }) =>
		loginText &&
		`font-size: 42px;
		line-height: 37px;
		color:${colors.Grey53};
		font-family: 'RubikBold'!important;
		margin-top:-79px;
		@media (max-width:992px){
			font-size: 28px;
			margin-top:0;
		}
		@media (max-width:860px){
			font-size: 24px;
		}
	`}
	${({ loginSubText }) =>
		loginSubText &&
		`font-size: 36px;
		line-height: 37px;
		color:${colors.Grey53};
		@media (max-width:992px){
			font-size: 28px;
		}
		@media (max-width:860px){
			font-size: 24px;
		}
	`}
	${({ loginHeading }) =>
		loginHeading &&
		`margin: 0 0 40px 0;
		text-align:left;
		position: relative;
		@media (max-width: 860px){
			margin: 0 0 30px 0;
		}
		@media (max-width: 530px){
			margin: 0 0 15px 0;
		}
		span{
			font-size: 32px;
			line-height: 37px;
			text-transform: uppercase;
			color:${colors.Grey53};
			font-family: 'RubikBold';
			@media (max-width: 530px){
				font-size: 22px;
			}
		}
	`}
	${({ loginHeadingSub }) =>
		loginHeadingSub &&
		`margin: 0 0 40px 0;
		text-align:left;
		position: relative;
		@media (max-width: 860px){
			margin: 0 0 30px 0;
		}
		@media (max-width: 530px){
			margin: 0 0 15px 0;
		}
		span{
			font-size: 32px;
			line-height: 37px;
			color:${colors.Grey53};
			font-family: 'RubikBold';
			@media (max-width: 530px){
				font-size: 22px;
			}
		}
	`}
	.uppercase{
		font-family: 'RubikMedium'!important;
		text-transform: capitalize;
	}
	
`;

export default Heading;
